<template>
    <div class="wrapper" :class="classes">
        <Sidebar v-if="withNavbar" class="sidebar"/>
        <transition name="fade">
            <Overlay v-if="withNavbar && open" class="overlay" @click="onSidebarClose"/>
        </transition>
        <div class="page">
            <Navbar v-if="withNavbar" @burger="onSidebarOpen"/>
            <div class="content">
                <ArrowLeft
                    v-if="withNavigation"
                    class="previous"
                    :color="config.COLOR_PRIMARY"
                    @click="onPrevious"
                />
                <slot/>
                <transition name="fade">
                    <Overlay v-if="analytics" @click="onAnalyticsClose"/>
                </transition>
                <transition name="slide-y">
                    <ModalAnalytics v-if="analytics" @close="onAnalyticsClose"/>
                </transition>
            </div>
            <Footer/>
        </div>
    </div>
</template>
<script>
import { TrackingConsumer, SolutionConsumer } from '../../mixins';

import { ModalAnalytics, Navbar, Sidebar } from '../../components/mobile';
import { Footer } from '../../components/shared';

export default {
    name: 'Page',
    components: {
        Navbar, Footer, Sidebar, ModalAnalytics,
    },
    mixins: [TrackingConsumer, SolutionConsumer],
    props: {
        withNavigation: {
            type: Boolean,
            default: false,
        },
        withNavbar: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            open: false,
            analytics: false,
        };
    },
    computed: {
        classes () {
            return {
                'with-navbar': this.withNavbar,
                open: this.open,
            };
        },
    },
    created () {
        this.analytics = this.shouldAskConsent;
    },
    methods: {
        onAnalyticsClose () {
            this.analytics = false;
        },
        onPrevious () {
            this.$router.go(-1);
        },
        onSidebarOpen () {
            this.open = true;
        },
        onSidebarClose () {
            this.open = false;
        },
    },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';

$sidebar-width: 300px;

.wrapper {
    position: relative;
    flex-grow: 1;
    display: flex;

    > .page {
        @include flex-vertical();
        flex-grow: 1;
        position: relative;

        > .content {
            @include flex-vertical();
            flex-grow: 1;
            position: relative;

            > .overlay {
                z-index: 1;
            }

            > .previous {
                position: absolute;
                top: 8px;
                left: 8px;
                z-index: 1;
            }
        }
    }

    &:not(.with-navbar) {
        flex-direction: column;
    }

    &.with-navbar {
        > .overlay {
            z-index: 1;
        }

        > .sidebar {
            position: fixed;
            z-index: 3;
            width: $sidebar-width;
            height: 100%;
            transform: translateX(-$sidebar-width);
            transition: transform .2s ease-out;
        }

        > .page {
            transition: transform .2s ease-out;
            max-width: 100%;
        }

            &.open {
                overflow: hidden;

                > .sidebar {
                    box-shadow: 10px 10px 32px 0 rgba($black, .2);
                    transform: none;
                }

                > .page {
                    transform: translateX($sidebar-width);
                }
            }
    }
}
</style>
